import React, { useMemo, useState } from "react";
import { FormGroup, Button } from "reactstrap";
import CasesApi from "../../api/CasesApi";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import Loader from '../Loader';
import Notification from "../Notification";


function FetchClientInfoButton(props) {
    const {
        formContext,
        schema: {
            title,
        },
        uiSchema: {
            'ui:readonly': readonly
        },
    } = props;
    console.log(props);
    const selectedIndex = formContext.formDefinition.curClientIdx || 0
    const id = formContext.fileField.postArgs.caseId || -1;
    const [isLoading, setIsLoading] = useState(false);
    const [newError, setError] = useState("");
    const { sideChannel } = formContext;
    const formObject = useSideChannelSubscription(sideChannel, 1) || [{}];
    async function fetchData(e) {
        e.preventDefault();
        if (isLoading) return;
        const clientType = formObject.clients[selectedIndex].clientTypeId || formObject.clients[0].clientTypeId || 1;
        let isBusiness = false;
        if (clientType !== 1 && clientType !== 4 ) {
            isBusiness = true;
        }

        const initialInfoBusiness = formObject.clients[selectedIndex].businessClientBasicInfo
        const initialInfoClient = formObject.clients[selectedIndex].retailClientBasicInfo

        const idType = isBusiness ? 1 : initialInfoClient.identificationType;

        const idString = !isBusiness ? (idType === 1 && initialInfoClient.identificationNumber ? initialInfoClient.identificationNumber :
            idType === 2 && initialInfoClient.passportNumber ? initialInfoClient.passportNumber :
                idType === 3 && initialInfoClient.foreignIdNumber ? initialInfoClient.foreignIdNumber : "") : initialInfoBusiness.identificationNumber
        
        if (idString === "") return;

        setIsLoading(true);
        let data;

        try {
            setError("");
            data = await CasesApi.getDataClient({ clientType, idString, idType, id });
            
        } catch (error) {
            setIsLoading(false);
            if (error.message === "Not Found") {
                setError("No se encontró cliente con este ID.");
            }
            else {
                setError(error.message);
            }

        }

        const dataSet = setClientData(data, isBusiness, idString);

        formContext.setFormDataValues(dataSet)
        setIsLoading(false);
    }

    return (
        <>
            {newError ? (<Notification color="danger">
                <div>{newError}</div>
            </Notification>) : null}
            {!readonly ? <FormGroup className="file-field" disabled={readonly || isLoading}><Button
                className="btn btn-secondary"
                target="_blank"
                onClick={(e) => fetchData(e)}
            >{isLoading ? <Loader /> : title}</Button></FormGroup> : <></>}
        </>

    );
}

function setClientData(data, isBusiness, clientId) {
    const clientIndex = isBusiness ?         
        data.clients.findIndex(client => client.businessClientBasicInfo?.identificationNumber === clientId) : 
        data.clients.findIndex(client => client.retailClientBasicInfo?.identificationNumber === clientId);
    const indexToUse = clientIndex === -1 ? 0 : clientIndex;
    return !isBusiness ? {
        "clientSchema.nombre": data.clients[indexToUse].retailClientBasicInfo?.firstName || "",
        "clientSchema.apellidos": data.clients[indexToUse].retailClientBasicInfo?.lastName || "",
        "clientSchema.segundoNombre": data.clients[indexToUse].retailClientBasicInfo?.secondName || "",
        "clientSchema.email": data.clients[indexToUse].retailClientBasicInfo?.email || "",
        "clientSchema.sexo": data.clients[indexToUse].retailClientBasicInfo?.sex || "",
        "clientSchema.telefono": data.clients[indexToUse].retailClientBasicInfo?.phone || "",
        "clientSchema.celular": data.clients[indexToUse].retailClientBasicInfo?.phoneMobile || "",
        "clientSchema.otro": data.clients[indexToUse].retailClientBasicInfo?.phoneOther || "",
        "clientSchema.estadoCivil": data.clients[indexToUse].retailClientBasicInfo?.civilStatus || "",
        "clientSchema.comentarios": data.clients[indexToUse].retailClientBasicInfo?.comments || "",
        "clientAditionalInfoSchema.fechaNacimiento": data.clients[indexToUse].retailClientBasicInfo?.dateOfBirth || "",
        "clientAditionalInfoSchema.lugarNacimiento": data.clients[indexToUse].retailClientBasicInfo?.countryOfBirth || "",
        "clientAditionalInfoSchema.nacionalidad": data.clients[indexToUse].retailClientBasicInfo?.nationality || "",
        "clientAditionalInfoSchema.direccionResidencia": data.clients[indexToUse].retailClientBasicInfo?.address || "",
        "clientAditionalInfoSchema.sector": data.clients[indexToUse].retailClientBasicInfo?.addressSector || "",
        "clientAditionalInfoSchema.ciudad": data.clients[indexToUse].retailClientBasicInfo?.city || "",
        "clientAditionalInfoSchema.pais": data.clients[indexToUse].retailClientBasicInfo?.country || "",
        "clientAditionalInfoSchema.residenteRD": data.clients[indexToUse].retailClientBasicInfo?.residentOfDominicanRepublic || "",
        "clientAditionalInfoSchema.residenciaFisicaUSA": data.clients[indexToUse].retailClientBasicInfo?.isAmericanResident || "",
        "clientAditionalInfoSchema.estatusMigratorio": data.clients[indexToUse].retailClientFatcaInfo?.unitedStatesImmigrationStatus || "",
        "clientAditionalInfoSchema.profesion": data.clients[indexToUse].retailClientBasicInfo?.profession || "",
        "clientAditionalInfoSchema.ocupacion": data.clients[indexToUse].retailClientBasicInfo?.occupation || "",
        "clientAditionalInfoSchema.ingresosMensuales": data.clients[indexToUse].retailClientBasicInfo?.monthlyIncome || "",
        "clientAditionalInfoSchema.zonaGeograficaNacional": data.clients[indexToUse].retailClientBasicInfo?.nationalGeographicZone || "",
        "clientAditionalInfoSchema.personaExpuestaPoliticamente": data.clients[indexToUse].retailClientPoliticalExposureInfo?.hasPoliticalExposure || "",
        "clientAditionalInfoSchema.parentescoPersonaExpuestaPoliticamente": data.clients[indexToUse].retailClientPoliticalExposureInfo?.hasPoliticalExposureRelative || "",
        "clientAditionalInfoSchema.sujetoObligadoLey155": data.clients[indexToUse].retailClientBasicInfo?.isSubjectToLaw15517 || "",
        "clientAditionalInfoSchema.vinculadoJMMB": data.clients[indexToUse].retailClientBasicInfo?.isRelatedToFranchise || "",
        "clientAditionalInfoSchema.beneficiariosDeTransaccion": data.clients[indexToUse].retailClientBasicInfo?.hasBeneficiaries || "",
        "clientAditionalInfoSchema.nombreBeneficiario": data.clients[indexToUse].retailClientBasicInfo?.beneficiaryName || "",
        "clientAditionalInfoSchema.ocupacionOtro": data.clients[indexToUse].retailClientBasicInfo?.otherOccupation || "",
        "clientAditionalInfoSchema.indicarPaises": data.clients[indexToUse].retailClientBasicInfo?.otherNationalities || "",
        "clientAditionalInfoSchema.nacionalidadOtroPais": data.clients[indexToUse].retailClientBasicInfo?.hasOtherNationality || "",
        "clientAditionalInfoSchema.tipoSujetoObligado": data.clients[indexToUse].retailClientBasicInfo?.obligationType || "",
        "clientAditionalInfoSchema.ingresosActividadesFormales": data.clients[indexToUse].retailClientBasicInfo?.isIncomeFromFormalActivities || "",
        "clientAditionalInfoSchema.otraFuenteIngresosFormales": data.clients[indexToUse].retailClientBasicInfo?.hasOtherSourcesOfIncome || "",
        "clientAditionalInfoSchema.idBeneficiario": data.clients[indexToUse].retailClientBasicInfo?.beneficiaryId || "",
        "clientAditionalInfoSchema.apellidoBeneficiario": data.clients[indexToUse].retailClientBasicInfo?.beneficiaryLastName || "",
    } :
    {
        "comercialSchema.nombreEmpresa": data.clients[indexToUse].businessClientBasicInfo?.businessName || "",
        "comercialSchema.actividadPrincipal": data.clients[indexToUse].businessClientBasicInfo?.businessMainActivity || "",
        "comercialSchema.tipoIdentificacionComercial": data.clients[indexToUse].businessClientBasicInfo?.identificationType || "",
        "comercialSchema.nombreContacto": data.clients[indexToUse].businessClientBasicInfo?.contactFirstName || "",
        "comercialSchema.apellidoContacto": data.clients[indexToUse].businessClientBasicInfo?.contactLastName || "",
        "comercialSchema.posicionContacto": data.clients[indexToUse].businessClientBasicInfo?.contactPosition || "",
        "comercialSchema.telefono": data.clients[indexToUse].businessClientBasicInfo?.phone || "",
        "comercialSchema.celular": data.clients[indexToUse].businessClientBasicInfo?.phoneMobile || "",
        "comercialSchema.email": data.clients[indexToUse].businessClientBasicInfo?.contactEmail || "",
        "comercialSchema.comentarios": data.clients[indexToUse].businessClientBasicInfo?.comments || "",
        "comercialSchema.numIdentificacionRNC": data.clients[indexToUse].businessClientBasicInfo?.identificationNumber || "",
        "infoRepLegal.nombreRep": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativeFirstName || "",
        "infoRepLegal.apellidoRep": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativeLastName || "",
        "infoRepLegal.posRep": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativePosition || "",
        "infoRepLegal.tipoId": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativeIdType || "",
        "infoRepLegal.numeroId": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativeIdNumber || "",
        "infoRepLegal.emailRep": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativeEmail || "",
        "infoRepLegal.telefonoRep": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativePhone || "",
        "infoRepLegal.celularRep": data.clients[indexToUse].businessClientBasicInfo?.legalRepresentativeCellphone || "",
        "datosEmpresa.fechaConst": data.clients[indexToUse].businessClientBasicInfo?.dateFounded || "",
        "datosEmpresa.lugarConst": data.clients[indexToUse].businessClientBasicInfo?.placeFounded || "",
        "datosEmpresa.dirResidencia": data.clients[indexToUse].businessClientBasicInfo?.address || "",
        "datosEmpresa.sector": data.clients[indexToUse].businessClientBasicInfo?.addressSector || "",
        "datosEmpresa.ciudad": data.clients[indexToUse].businessClientBasicInfo?.city || "",
        "datosEmpresa.pais": data.clients[indexToUse].businessClientBasicInfo?.country || "",
        "datosEmpresa.houseNo": data.clients[indexToUse].businessClientBasicInfo?.houseNo || "",
        "datosEmpresa.buildingNo": data.clients[indexToUse].businessClientBasicInfo?.buildingNo || "",
        "datosEmpresa.zonaGeograficaNacional": data.clients[indexToUse].businessClientBasicInfo?.nationalGeographicZone || "",
        "datosEmpresa.website": data.clients[indexToUse].businessClientBasicInfo?.businessWebsite || "",
        "datosEmpresa.nombreDirectores": data.clients[indexToUse].businessClientGeneralInfo?.directorNames || "",
        "datosEmpresa.numEmpleados": data.clients[indexToUse].businessClientGeneralInfo?.numEmployees || "",
        "datosEmpresa.promMensVentas": data.clients[indexToUse].businessClientGeneralInfo?.avgMonthlySales || "",
        "datosEmpresa.prodServOfrecen": data.clients[indexToUse].businessClientGeneralInfo?.offering || "",
        "datosEmpresa.empresasAfiliadas": data.clients[indexToUse].businessClientGeneralInfo?.associatedBusinesses.map(element => ({
            "nombreRazonSocial": element.nameOrSocialReason || "",
            "rncNumber": element.rncNumber || "",
        })),
        "datosEmpresa.principalesProveedores": data.clients[indexToUse].businessClientGeneralInfo?.mainProviders.map(element => ({
            "nombre": element.name || "",
        })),
        "datosEmpresa.principalesAccionistas.princAccionList": data.clients[indexToUse].businessClientGeneralInfo?.mainInvestors.map(element => ({
            "nombreCompleto": element.name || "",
            "participacionAccionaria": element.shareholding || "",
            "nacionalidad": element.nationality || "",
            "ciudadaniaUSA": element.hasUnitedStatesCitizenship || "",
            "numeroIdent": element.identificationNumber || "",
            "benefFinal": element.finalBeneficiary || "",
        })),
        "datosEmpresa.miembrosOrganoDireccion": data.clients[indexToUse].businessClientGeneralInfo?.businessClientBoardMembers.map(element => ({
            "nombreCompleto": element.boardMemberName || "",
            "posicion": element.boardMemberPosition || "",
            "nacionalidad": element.boardMemberNationality || "",
            "numeroIdent": element.boardMemberIdNumber || "",
        })),
    };
}


export default FetchClientInfoButton;